<mat-dialog-content class="mat-typography" style="max-width: 750px;">
  
    <h1 mat-dialog-title>Zähleranschlusssäule löschen?</h1>
    <div *ngIf="chargingStationChanged">
    <p>
      Das Ändern der Ladestation hat zur Folge, dass die im Projekt enthaltene
      Zähleranschlusssäule "{{dialogData.emuEntry.description}}" mit der Artikelnummer {{dialogData.emuEntry.productId}} gelöscht wird.
    </p>
    <p>
      Sind sie sicher, dass sie die Ladestation ändern und die Zähleranschlusssäule aus dem Projekt entfernen möchten?
    </p>
  </div>

  <div *ngIf="chargingStationDeleted">
    <p>
      Das Löschen der Ladestation "{{dialogData.csEntry.description}}" mit der Artikelnummer {{dialogData.csEntry.productId}} hat zur Folge, dass auch die im Projekt enthaltene 
      Zähleranschlusssäule "{{dialogData.emuEntry.description}}" mit der Artikelnummer {{dialogData.emuEntry.productId}} gelöscht wird.
    </p>
    <p>
      Sind sie sicher, dass sie die Ladestation inklusive der Zähleranschlusssäule aus dem Projekt entfernen möchten?
    </p>
  </div>
  
  <div *ngIf="alignedToProductUpdates">
    <p>
      Das Übernehmen der Artikelstammdatenänderungen hat zur Folge, dass die im Projekt enthaltene 
      Zähleranschlusssäule "{{dialogData.emuEntry.description}}" mit der Artikelnummer {{dialogData.emuEntry.productId}} gelöscht wird.
    </p>
    <p>
      Sind sie sicher, dass sie die Artikelstammdatenänderungen übernehmen und die Zähleranschlusssäule aus dem Projekt entfernen möchten?
    </p>
  </div>
  
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial (click)="cancel()">Nein</button>
  <button mat-button (click)="confirmDeletion()">Ja</button>
</mat-dialog-actions>
